const RegexUrl = atob('XihodHRwfGh0dHBzPyk6XC9cL1teICJdKyQ=');
const RegexEmail = atob('XigoW148PigpXFtcXVxcLiw7OlxzQCJdKyhcLltePD4oKVxbXF1cXC4sOzpcc0AiXSspKil8KCIuKyIpKUAoKFxbWzAtOV17MSwzfVwuWzAtOV17MSwzfVwuWzAtOV17MSwzfVwuWzAtOV17MSwzfV0pfCgoW2EtekEtWlwtMC05XStcLikrW2EtekEtWl17Mix9KSkk');
const RegexFTPAddress = atob('XihmdHA6XC9cLyk/KCgoW2EtekEtWlxkXShbYS16QS1aXGQtXSpbYS16QS1aXGRdKSopXC4pK1thLXpBLVpdezIsfXwoKFxkezEsM31cLil7M31cZHsxLDN9KSkoXDpcZCspPyhcL1stYS16QS1aXGQlXy5+K10qKSooXD9bOyZhLXpBLVpcZCVfLn4rPS1dKik/KFwjWy1hLXpBLVpcZF9dKik/JA==');
const RegexSFTPAddress = atob('XihzZnRwOlwvXC8pPygoKFthLXpBLVpcZF0oW2EtekEtWlxkLV0qW2EtekEtWlxkXSkqKVwuKStbYS16QS1aXXsyLH18KChcZHsxLDN9XC4pezN9XGR7MSwzfSkpKFw6XGQrKT8oXC9bLWEtekEtWlxkJV8ufitdKikqKFw/WzsmYS16QS1aXGQlXy5+Kz0tXSopPyhcI1stYS16QS1aXGRfXSopPyQ=');

export function IsValidUrl (str: string) {
  const pattern = new RegExp(RegexUrl);
  return pattern.test(str);
}

// https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url :-)
export function IsValidHTTPSUrl(str: string) {
  let url;

  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }

  return url.protocol === "https:";
}


export function IsValidEmail(str: string) {
  const pattern = new RegExp(RegexEmail);
  return pattern.test(str);
}

export function IsValidFTPAddress (str: string) {
  const pattern = new RegExp(RegexFTPAddress);
  return pattern.test(str);
}

export function IsValidSFTPAddress (str: string) {
  const pattern = new RegExp(RegexSFTPAddress);
  return pattern.test(str);
}



// WEBPACK FOOTER //
// ./src/modules/core/helpers/ValidationHelper.tsx